import { BaseService } from "./base.service";
export class ProgramTypeService extends BaseService {
  constructor() {
    super("program-types");
  }
}
